import type { SVGProps } from 'react'

import { cn } from '@gto/ui/cn'

/**
 * Animated spinner icon matching MUI CircularProgress indeterminate style.
 * Uses Tailwind animation classes for the "growing arc" effect.
 */
export const Spinner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 44 44"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={cn('animate-spinner-rotate', props.className)}
  >
    <circle
      className="animate-spinner-dash"
      cx="22"
      cy="22"
      fill="none"
      r="20.2"
      stroke="currentColor"
      strokeDasharray="80px, 200px"
      strokeDashoffset="0"
      strokeWidth="3.6"
    />
  </svg>
)
